import { Feedbacks } from "@/blocks/Feedbacks/Feedbacks";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

const noop = () => {};
const noopUpdated = () => {};

export function PlaygroundFeedbacks() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Default (neutral thumbs) — click to rate, click the label to reset
        </PlaygroundSubSectionTitle>
        <Feedbacks
          onClickThumbUp={noop}
          onClickThumbDown={noop}
          onClickThumbUpUpdated={noopUpdated}
          onClickThumbDownUpdated={noopUpdated}
        />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Inline next to text (mirrors the Insights mood / CSAT rows)
        </PlaygroundSubSectionTitle>
        <div className="flex items-center gap-4">
          <span className="text-xs font-medium text-muted-foreground">
            Customer mood
          </span>
          <Feedbacks onClickThumbUp={noop} onClickThumbDown={noop} />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
